import * as THREE from 'three';
import { scalePoint } from './scalePoint';

/**
 * Scales the corner points of any polygon by a given factor on the x and y axes.
 *
 * @param {THREE.Vector3[]} polygonPoints - Array of corner points of the polygon to be scaled.
 * @param {number} factor - Scaling factor (positive for upscaling, negative for downscaling).
 * @param {THREE.Vector3} origin - Origin point for scaling.
 * @returns {THREE.Vector3[]} Scaled corner points.
 */
export const scalePolygon = (
  polygonPoints: THREE.Vector3[],
  factor: number,
  origin: THREE.Vector3 = new THREE.Vector3(0, 0, 0),
): THREE.Vector3[] => polygonPoints.map((point) => scalePoint(point, factor, origin));
